import { Link } from 'react-router-dom'
import { Card } from '../../components/ui/Card'
import { EmptyState } from '../../components/ui/EmptyState'

/** Aviso no lugar do conteúdo de um recurso que o plano atual não inclui. */
export function BloqueioRecurso({ mensagem = 'Este recurso não está incluído no seu plano.' }: { mensagem?: string }) {
  return (
    <Card>
      <EmptyState
        icon="ri-lock-line"
        message={mensagem}
        action={<Link to="/plano" className="inline-flex h-[38px] items-center gap-2 rounded bg-primary/10 px-4 text-13 font-medium text-primary hover:bg-primary hover:text-bg">Ver planos</Link>}
      />
    </Card>
  )
}
